module.exports = __webpack_public_path__ + "img/bg1.cca6e48e.jpg";